<template>
    <div>
        <v-toolbar flat color="white">
            <v-spacer></v-spacer>
            <v-text-field label="Search" v-model="search"></v-text-field>
    </v-toolbar>
    <v-data-table :headers="headers" :items="customerAccount" :loading="isLoading" hide-actions style="cursor:pointer">
        <template v-slot:items="props">
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)">
          <v-chip v-if="props.item.status=='Live'" color="light-green" class="white--text">Live</v-chip>
          <v-chip v-else-if="props.item.status=='Pending'" color="blue" class="white--text">Pending</v-chip>
          <v-chip v-else-if="props.item.status=='Suspended'" color="orange" class="white--text">Suspended</v-chip>
          <v-chip v-else-if="props.item.status=='Inactive'" color="red" class="white--text">Inactive</v-chip>


        </td>
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)">{{props.item.accountStatus}}</td>
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)">{{props.item.supplierOrganisation.name}}</td>

          <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-if="props.item.serviceAccount">{{props.item.serviceAccount.circuitNumber}}</td>
          <td v-else></td>
          <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-if="props.item.serviceAccount">{{props.item.serviceAccount.location.locationDescription}}</td>
          <td v-else></td>
          <td class="text-xs-center" v-if="props.item.contractTerm == 1">Month-to-Month</td>
          <td class="text-xs-center" v-else>{{props.item.contractTerm}} Month</td>
          <td class="text-xs-center" >{{formatDate(props.item.startDate)}}</td>
          <td class="text-xs-center" @click="routerLinkToDetails(props.item)">{{props.item.contact.name +' ' + props.item.contact.surname}}</td>


        </template>
    </v-data-table>
     <div class="text-xs-center pt-2 white" :key="$route.query.offset" v-if="Math.ceil(totalItems/$route.query.records)>1">
        <v-layout wrap>
          <v-flex xs12>
            <v-pagination
              v-model="activePage"
              :length="Math.ceil(totalItems/$route.query.records)"
              :total-visible="7"
            ></v-pagination>
          </v-flex>
        </v-layout>
      </div>
    </div>
</template>
<script>
import Api from "@/services/Api";
import dateformat from "dateformat";
export default {
    data(){
        return {
            activePage: 1,
            activePagination: {},
            customerAccount: [],
            search: '',
            totalItems: 0,
            isLoading: true,
            headers: [{
          text: "Connection Status",
          align: "center",
          sortable: false
        },
        {
          text: "Account Status",
          align: "center",
          sortable: false
        },
        {
          text: "Network Operator",
          align: "center",
          value: "supplierOrganisation.name",
          sortable: false
        },
       {
          text: "Circuit Number",
          align: "center",
          value: "circuitNumber",
          sortable: false
        },
        {
          text: "Location",
          align: "center",
          value: "location.locationDescription",
          sortable: false
        },
        {
          text: "Contract Term",
          align: "center",
          sortable: false
        },
         {
          text: "Contract Start Date",
          align: "center",
          sortable: false
        },
        {
          text: "Customer",
          align: "center",
          value: "contact.name",
          sortable: false
        },
            ]
        }
    },
    watch: {
          '$route.query.search':{
      immediate: true,
      handler(value){
        this.isLoading=true
      if(this.$route.query.search&&value!==""&&value != null){
        this.activePage = 1
        Api()
        .get('/customerAccount',{
          params: {
          search: this.$route.query.search,
          offset: '0',
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.customerAccount=response.data.result
          this.totalItems=response.data.count
            this.isLoading=false
          })} else if(this.$route.query.activeOffset){
             Api()
        .get('/customerAccount',{
          params: {
          offset: this.$route.query.offset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.customerAccount=response.data.result
          this.totalItems=response.data.count
            this.isLoading=false})
          }
      }
    },
    '$route.query.offset': {
       immediate: true,
      handler(value){
        this.isLoading=true
      if(value!==""&&value != null&&this.$route.query.search&&this.$route.query.search!="" &&this.$route.query.search!== null){      
        
        Api()
        .get('/customerAccount',{
          params: {
          search: this.$route.query.search,
          offset: this.$route.query.offset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.customerAccount=response.data.result
          this.totalItems=response.data.count
            this.isLoading=false})
      } else if(value != null){
         Api()
        .get('/customerAccount',{
          params: {
          offset: this.$route.query.offset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.customerAccount=response.data.result
          this.totalItems=response.data.count
            this.isLoading=false})
      }
    }},
     activePage(value) {
      this.activePagination.page = this.activePage;
      if (value && value != "" && value != this.$route.query.records) {
        if (this.$route.query.search) {
          this.$router.push({
            name: this.$route.name,
            query: {
              offset: (value - 1) * this.$route.query.records,
              records: this.$route.query.records
            }
          });
        } else {
          this.$router.push({
            name: this.$route.name,
            query: {
              offset: (value - 1) * this.$route.query.records,
              records: this.$route.query.records,
              search: this.$route.query.search,
            }
          });
        }
      }
    }
    },
    created(){
        this.$router.push({
      name: this.$route.name,
      query: {
        offset: "0",
        records: "15",
        search: "0"
      }
    });
    },
    methods: {
      formatDate(date) {
      if (date !== null) {
        return dateformat(date, "dd/mm/yyyy");
      } else {
        null;
      }
    },
        routerLinkToDetails(item){
            this.$router.push({ path: "/customerAccount/" + item.id });
        }
    }
}
</script>